import React, { useRef } from 'react';
import Layout from '../components/Layout';
import { Link } from 'react-router-dom';

const Preview = () => {
    return (
        <Layout headerStyle2={true}>
            <div className="bg-banner">
                <img src="/images/banner1.jpg" alt="预览视频" />
                <h3>预览视频</h3>
            </div>

            <div className="route">
                <div className="container">
                    <ul>
                        <li><Link to="/">首页</Link></li>
                        <li><Link to="/preview">预览视频</Link></li>
                    </ul>
                </div>
            </div>

            <div className="page-photo">
                <div className="container">
                    <div className="index-title center">
                        <font color="pink" className="fontSize">部分MV预览</font>
                    </div>
                    <div className="index-bottom">
                        <font className="fontSize1">By&nbsp;:&nbsp;</font>
                        <a href="https://space.bilibili.com/400813602" target="_blank" rel="noreferrer">
                            <svg className="icon" viewBox="0 0 1024 1024" width="4rem" style={{ marginLeft: '.1225rem', cursor: 'pointer' }}>
                                <path d="M318.05 116.04c10.74-6.72 25.89-4.86 34.61 4.37 35.79 35.88 71.74 71.62 107.48 107.55 1.25 1.28 3.25 0.7 4.85 0.9 34.14-0.16 68.28 0.21 102.42-0.19 35.97-36.44 72.41-72.44 108.53-108.74 9.36-9.62 25.91-10.55 36.45-2.29 10.05 7.43 13.96 22 8.73 33.4-2.19 6.01-7.35 10.03-11.63 14.49-21.15 21.01-42.05 42.29-63.35 63.16 53.95 0.38 107.91-0.02 161.87 0.2 21.23 0.4 42.19 7.41 59.66 19.42 26.18 17.72 44.8 45.12 54.9 74.82 6.23 18.27 9.3 37.56 9.39 56.84 0.01 103.66 0 207.33 0 310.99-0.09 11.02 0.28 22.06-0.43 33.07-2.71 38.2-17.7 76.22-44.93 103.58-20.45 21.06-48.98 34.9-78.59 35.12-12.55 0-25.1 0.11-37.65-0.08-0.63 4.22-0.84 8.53-2.01 12.66-3.34 12.23-11.98 22.96-23.29 28.73-11.36 6.21-25.39 6.96-37.51 2.58-14-4.95-25.24-17.08-29.07-31.43-1.26-4.05-1.53-8.31-1.94-12.5-108.34 0.09-216.67 0.12-325.01-0.01-0.34 12.71-5.52 25.3-14.88 34.02-8.64 8.32-20.68 12.95-32.66 12.68-14.96-0.05-29.65-7.96-37.93-20.42-3.64-5.23-5.97-11.29-7.3-17.5-0.42-2.95-0.49-5.96-1.16-8.86-12.86 0.31-25.72 0.09-38.58 0.14-21.39 0.18-42.63-6.6-60.39-18.43-26.63-17.63-45.74-45.15-56.02-75.14-6.56-18.97-9.73-39.09-9.54-59.15-0.01-105.68-0.01-211.35 0-317.03 0.04-8.97-0.23-17.95 0.49-26.89 2.45-30.85 12.9-61.26 31.29-86.27 12.87-17.43 29.75-32.19 49.58-41.17 13.64-6.35 28.64-9.53 43.66-9.81 54.61-0.06 109.22 0.07 163.83-0.08-22.98-22.56-45.57-45.54-68.44-68.22-3.99-3.9-7.01-8.9-8.16-14.39-2.79-11.38 2.58-24.22 12.73-30.12m-85.92 197.13c-10.33 1.26-19.96 6.43-27.17 13.86-10.25 10.63-15.85 25.3-16.21 40-0.01 115.64 0 231.29 0 346.94 0.07 6.31-0.39 12.68 0.78 18.93 1.24 8.65 4.56 16.92 9.3 24.24 7.48 11.11 19.39 19.54 32.81 21.41 4.11 0.34 8.25 0.18 12.38 0.25 181-0.02 361.99 0.02 542.99-0.01 13.26 0.46 26.08-6.12 34.72-15.97 10.28-11.6 15.08-27.43 14.51-42.8-0.02-117.67-0.01-235.34 0-353-0.32-11.62-3.83-23.19-10.42-32.8-6.51-9.79-16.57-17.36-28.07-20.11-6.44-1.73-13.14-1.26-19.72-1.3-177.33-0.01-354.67 0-532 0-4.63 0.03-9.29-0.21-13.9 0.36z" fill="#fb7299"></path>
                                <path d="M250.05 464.67c56.01-10.78 112.01-21.72 168.04-32.43 3.88 22.34 8.72 44.5 12.75 66.81-58.43 11.07-116.77 22.7-175.21 33.71-4.57-22.05-8.33-44.28-13.12-66.27 2.42-0.92 4.98-1.41 7.54-1.82zM610.68 432.14c57.9 11.29 115.81 22.55 173.77 33.57-4.07 22.32-8.52 44.58-12.82 66.85-57.84-11.04-115.63-22.41-173.46-33.46-0.11-0.13-0.33-0.4-0.44-0.54 4.49-22.1 8.63-44.28 12.95-66.42zM511.82 606.29c0.32-0.01 0.96-0.05 1.28-0.06 8.42 12.72 15.3 26.67 25.95 37.77 5.78 5.81 13.26 11.34 21.9 10.72 8.6-0.73 15.94-6.05 22.16-11.64 4.71-4.58 9.31-9.34 12.87-14.9 9.56 6.24 19.65 11.71 28.81 18.55-10.33 14.56-23.06 28.11-39.35 35.96-13.68 6.75-30.12 8.21-44.51 2.82-11.01-3.85-20.26-11.38-28.19-19.76-4.1 3.19-7.38 7.33-11.71 10.28-11.51 9.1-26.41 14.12-41.12 12.5-18.33-1.75-34.29-12.73-46.75-25.67-4.53-5.39-9.59-10.47-12.93-16.73 9.74-5.68 19.04-12.09 28.7-17.89 7.39 10.12 16.29 20.04 28.12 24.89 6.99 3.04 15.24 1.64 21.33-2.76 12.85-8.82 19.99-23.14 28.31-35.83 1.75-2.72 3.46-5.47 5.13-8.25z" fill="#fb7299"></path>
                            </svg>
                        </a>
                    </div>

                    <div className="item-all">
                        <div className="style3s">
                            <PreviewItem videoSrc="/video/YOASOBI アイドル(Idol) Official Music Video.mp4" imgSrc="/images/videoAidoru.jpg" title="《アイドル》" bvid="BV17h411u7sb" />
                            <PreviewItem videoSrc="/video/YOASOBI「HEART BEAT」Official Music Video.mp4" imgSrc="/images/videoHatobito.jpg" title="《HEART BEAT》" bvid="BV12N4y1z73t" />
                            <PreviewItem videoSrc="/video/YOASOBI「勇者」Official Music Video.mp4" imgSrc="/images/videoYuusha.jpg" title="《勇者》" bvid="ep780514" />
                        </div>
                        <div className="style3s">
                            <PreviewItem videoSrc="/video/YOASOBI 大正浪漫(Romance) Official Music Video.mp4" imgSrc="/images/video大正浪漫.jpg" title="《大正浪漫》" bvid="BV13f4y1n7oD" />
                            <PreviewItem videoSrc="/video/YOASOBI アドベンチャー(ADVENTURE) Official Music Video.mp4" imgSrc="/images/videoAdobencha.jpg" title="《アドベンチャー》" bvid="BV1Kh411V7qp" />
                            <PreviewItem videoSrc="/video/YOASOBI ラブレター(Love Letter) Official Music Video.mp4" imgSrc="/images/videoRabureta.jpg" title="《ラブレター》" bvid="BV1Nh411H7ga" />
                        </div>
                        <div className="style3s">
                            <PreviewItem videoSrc="/video/YOASOBI 好きだ(Suki da) Official Music Video.mp4" imgSrc="/images/videoSukida.jpg" title="《好きだ》" bvid="BV1Mg411q7Ev" />
                            <PreviewItem videoSrc="/video/YOASOBI 三原色(RGB) Official Music Video.mp4" imgSrc="/images/videoSanyuanse.jpg" title="《三原色》" bvid="BV1qv41137oN" />
                            <PreviewItem videoSrc="/video/YOASOBI たぶん(Tabun) Official Music Video.mp4" imgSrc="/images/videoTabun.jpg" title="《たぶん》" bvid="BV19t4y1B7xo" />
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

const PreviewItem = ({ videoSrc, imgSrc, title, bvid }) => {
    const videoRef = useRef(null);
    const containerRef = useRef(null);

    const handleMouseEnter = () => {
        if (videoRef.current) {
            videoRef.current.volume = 0.1;
            videoRef.current.style.display = 'block';
            videoRef.current.play().catch(e => console.log("Play failed", e));
        }
    };

    const handleMouseLeave = () => {
        if (videoRef.current) {
            videoRef.current.pause();
            videoRef.current.style.display = 'none';
        }
    };

    return (
        <div className="img" ref={containerRef} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <div className="video-container">
                <video
                    ref={videoRef}
                    className="video-preview"
                    controls
                    loop={true}
                    muted={false}
                    style={{ display: 'none' }}
                >
                    <source src={videoSrc} type="video/mp4" />
                </video>
                <img className="video-smallphoto" src={imgSrc} alt={title} />
                <a href={`https://www.bilibili.com/video/${bvid}`} target="_blank" rel="noreferrer">
                    <p align="center" className="pMargin">
                        <font color="#00CCCC" size="4">{title}</font>
                    </p>
                </a>
            </div>
        </div>
    );
};

export default Preview;
